
























































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { getCountries } from "@/utils/countries";
import "vue-select/dist/vue-select.css";
import { namespace } from "vuex-class";
import {
  CompanyDocumentUploadPayload,
  UpdateCompanyPayload,
} from "@/modules/company/types";
import { required } from "vuelidate/lib/validators";
import { base64toBlob, getBase64 } from "@/utils/index";
import CircularLoader from "@/components/svg/CircularLoader.vue";
import PreviousPageArrow from "@/components/PreviousPageArrow.vue";

const Company = namespace("company");

@Component({
  metaInfo() {
    return {
      title: "Orba One | Company Information",
    };
  },
  components: {
    "circular-loader": CircularLoader,
    "previous-page-arrow": PreviousPageArrow,
  },
  mixins: [validationMixin],
})
export default class GeneralInfo extends Vue {
  @Company.Action("uploadDocument") upload!: (
    payload: CompanyDocumentUploadPayload
  ) => Promise<{}>;
  @Company.Action("updateCompanyInfo") updateCompanyInfo!: (
    payload: UpdateCompanyPayload
  ) => Promise<{}>;

  uploadedFiles = [] as any;
  countries = [];
  documentPreviewUrls = [] as any;
  loading = false;

  companyInfoForm = {
    companyName: "",
    registrationNumber: "",
    country: null,
  };

  remove(index: number) {
    this.$delete(this.uploadedFiles, index);
    this.$delete(this.documentPreviewUrls, index);
  }

  validations() {
    return {
      companyInfoForm: {
        companyName: {
          required,
        },
        registrationNumber: {
          required,
        },
        country: {
          required,
        },
      },
    };
  }

  async mounted() {
    this.countries = await getCountries();
  }

  async previewFiles(event) {
    this.uploadedFiles.push(event.target.files[0]);
    this.blobToDataURL(event.target.files[0], (res) => {
      this.documentPreviewUrls.push(res);
    });
    // Allows the same file to be uploaded, removed and uploaded again
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this.$refs.fileupload.value = null;
  }

  blobToDataURL(blob, callback) {
    // NB: Data URLs point to files/images stored in the browsers memory
    // and can be used to display document previews
    const fileReader = new FileReader();
    fileReader.onload = function (e) {
      return callback(e.target!.result);
    };
    fileReader.readAsDataURL(blob);
  }

  async submitForm() {
    this.loading = true;
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const companyId = params.get("companyId");
    if (publicKey && companyId) {
      // convert files to base 64
      const files = [] as any;
      for await (const uploadedFile of this.uploadedFiles) {
        const converted = await getBase64(uploadedFile);
        const formData = new FormData();
        formData.append("publicKey", publicKey);
        formData.append("name", uploadedFile.name);
        formData.append("type", uploadedFile.type);
        const fileBlob = await base64toBlob(converted);
        formData.append("file", fileBlob, uploadedFile.name);
        files.push(formData);
      }
      await this.updateCompanyInfo({
        companyId: companyId,
        name: this.companyInfoForm.companyName,
        countryCode: this.companyInfoForm.country!["code"],
        registrationNumber: this.companyInfoForm.registrationNumber,
        publicKey: publicKey,
        documents: files,
      });

      this.loading = false;
      this.$router.push({ name: "ubo" });
    }
  }
}
